import React, { useState, useEffect } from 'react';
import { Box, TextField, Button } from '@mui/material';
import { SectionWithId } from './MetadataInterfaces';

interface SectionFormProps {
  section?: SectionWithId;
  onSave: (section: Omit<SectionWithId, 'id' | 'fields'>) => void;
  onCancel: () => void;
}

const SectionForm: React.FC<SectionFormProps> = ({
  section,
  onSave,
  onCancel,
}) => {
  const [name, setName] = useState(section?.name || '');

  useEffect(() => {
    if (section) {
      setName(section.name);
    }
  }, [section]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ name });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <TextField
        fullWidth
        label="Section Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        margin="normal"
        placeholder="Enter section name (optional)"
      />
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onCancel} sx={{ mr: 1 }}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default SectionForm;
